import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { connect } from '../components/runtime-context';
import wrapDisplayName from 'recompose/wrapDisplayName';
import { omit, flowRight } from 'lodash';
import { getCurrentUser, isBlocked, isOwner, isPrivate } from '@wix/communities-blog-client-common';
import { getIsMemberAreaInstalled } from '../store/communities-context/communities-context-selectors';
import { isSite } from '../store/basic-params/basic-params-selectors';
import { isAuthenticated } from '../store/auth/auth-selectors';

const NAME = 'withAuth';

export default function withAuth(WrappedComponent) {
  class WithAuth extends Component {
    static displayName = wrapDisplayName(WrappedComponent, NAME);
    static propTypes = {
      showJoinCommunityPopup: PropTypes.func,
      isPrivate: PropTypes.bool,
      isAuthenticated: PropTypes.bool,
      __isMemberAreaActive: PropTypes.bool,
      __isSite: PropTypes.bool,
    };

    forPublicUser = (fn, options) => {
      if (!this.props.__isMemberAreaActive || !this.props.__isSite) {
        return fn;
      }
      return this.decorateWithPrivacyChecker(fn, options);
    };

    decorateWithPrivacyChecker = (fn, { preventDefault = false } = {}) => {
      const isPrivate = () => this.props.isPrivate;
      const isAuthenticated = () => this.props.isAuthenticated;
      const showJoinCommunityPopup = () => this.props.showJoinCommunityPopup();

      return function (...args) {
        if (preventDefault) {
          const event = args[0];
          event.preventDefault && event.preventDefault();
        }

        if (isAuthenticated() && isPrivate()) {
          showJoinCommunityPopup();
        } else {
          return fn.apply(this, args);
        }
      };
    };

    render() {
      const props = omit({ forPublicUser: this.forPublicUser, ...this.props }, [
        '__isMemberAreaActive',
        '__isSite',
        'showJoinCommunityPopup',
      ]);
      return <WrappedComponent {...props} />;
    }
  }

  hoistNonReactStatics(WithAuth, WrappedComponent);

  return flowRight(connect(mapRuntimeToProps))(WithAuth);
}

function mapRuntimeToProps(state, ownProps, actions) {
  return {
    showJoinCommunityPopup: actions.showJoinCommunityPopup,
    currentUser: getCurrentUser(state),
    isAuthenticated: isAuthenticated(state),
    isBlocked: isBlocked(state),
    isOwner: isOwner(state),
    isPrivate: isPrivate(state),
    __isMemberAreaActive: getIsMemberAreaInstalled(state),
    __isSite: isSite(state),
  };
}
